<template>
  <IconButtonGroup class="category-list-group-item ps-4">
    <IconButton
      icon-name="material-symbols:edit-square-outline"
      class="text-primary"
      @keypress.stop
      @click.stop="$emit('update', $event)"
    />
    <IconButton
      icon-name="material-symbols:delete-outline"
      class="text-danger"
      @keypress.stop
      @click.stop="$emit('delete', $event)"
    />
  </IconButtonGroup>
</template>
<script lang="ts" setup>
defineEmits<{
  update: [Event];
  delete: [Event];
}>();
</script>
